import { render, staticRenderFns } from "./ASLCloseButton.vue?vue&type=template&id=636c69cb&scoped=true"
import script from "./ASLCloseButton.vue?vue&type=script&lang=js"
export * from "./ASLCloseButton.vue?vue&type=script&lang=js"
import style0 from "./ASLCloseButton.vue?vue&type=style&index=0&id=636c69cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636c69cb",
  null
  
)

export default component.exports